import React, { useState } from "react"
//import { LanguageContext } from "../../context"
import {useStaticQuery, graphql } from "gatsby"
//import Button from "../button-generic"
import Modal from "react-bootstrap/Modal"
import Webform, { useWebformElement, WebformElementWrapper } from "../../../plugins/gatsby-drupal-webform-unida"
import { useToasts } from 'react-toast-notifications'
import Alert from 'react-bootstrap/Alert'
import { decode } from 'he'


 const ModalUnida = (props) => {

   const {
      handleShow,
      showModal,
      backgroundimage='',
      className='',
      theform,
      footer,
      title,
      description,
      sendMessage,
      lang,
      children,
      formId,
      formData,
      project,
      ...rest
    } = props

   const { addToast } = useToasts()
   const [showAlert, setShowAlert] = useState(false)
   const [alertMessage, setAlertMessage] = useState("")

   const data = useDataFormModal()


  const formWorkWithUs = data?.form_work_with_us
  const formAskPrayer = data?.form_prayer
  const formWelcome = data?.form_welcome
  const formDonate = data?.form_donate
  const formVolunteer = data?.form_volunteer
  const showmessage = (response) => {
    const { settings } = response
    const { confirmation_message } = settings
    props.onHide()
    addToast(decode(confirmation_message), {
      appearance: 'info',
      autoDismiss: true,
      autoDismissTimeout: 6000
    })
  }

  const showerrormessage = (response) => {
    if(response?.code === "ERR_BAD_REQUEST" ){
       setShowAlert(true)
       setAlertMessage(response?.message)
    }
  }


  /*formVolunteer.elements.push({
    'name': 'project',
    'options': '',
    'type': 'hidden',
    'value': project,
    'attributes': [
        {
            "name": "#title",
            "value": "Project"
        },
        {
            "name": "#required",
            "value": "0"
        },
        {
            "name": "#default_value",
            "value": project
        }
    ]
  })*/


   return (
    <>
      <Modal {...rest} aria-labelledby="contained-modal-title-vcenter" >
        <Modal.Header
          closeButton
          style={{
              backgroundImage: `url(${backgroundimage})`,
              lineHeight : 10,
              padding: 20,
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
              backgroundPosition: 'center',
            }}
          className={className}
        >
        </Modal.Header>

        <Modal.Body>
            <Modal.Title
            className="H3-Bold-C---orange"
            >
            {title}
            </Modal.Title>
            <p className="H5-Medium-C---black m-b-48 p-l-r-112">
              {description}
            </p>

            <Alert variant="danger" show={showAlert} onClose={() => setShowAlert(false)} dismissible>
              <Alert.Heading>Error enviant formulari.</Alert.Heading>
              <p>
                {alertMessage || "Hi ha hagut un error enviant el formulari."}
              </p>
            </Alert>

            {/*theform && theform === 'treballar_goel' &&
              <ModalForm
                data={formWorkWithUs}
                sendmessage={sendMessage}
                showmessage={showmessage}
                showerrormessage={showerrormessage}
                lang={lang}
                formId={theform}
              />
             */}

            {/*theform && theform === 'ask_for_prayer' &&
              <ModalForm
                data={formAskPrayer}
                sendmessage={sendMessage}
                showmessage={showmessage}
                showerrormessage={showerrormessage}
                lang={lang}
                formId={theform}
              />
            */}


            {/*theform && theform === 'care_for_vulnerable_families' &&
              <ModalForm
                data={formData}
                sendmessage={sendMessage}
                showmessage={showmessage}
                showerrormessage={showerrormessage}
                lang={lang}
                formId={theform}
              />
            */}

            {theform && theform === 'visit_us_goel_webform' &&
              <ModalForm
                data={formWelcome}
                sendmessage={sendMessage}
                showmessage={showmessage}
                showerrormessage={showerrormessage}
                lang={lang}
                formId={theform}
              />
            }

            {theform && theform === 'donacio_en_linea' &&
                <ModalForm
                  data={formDonate}
                  sendmessage={sendMessage}
                  showmessage={showmessage}
                  showerrormessage={showerrormessage}
                  lang={lang}
                  formId={theform}
                />
            }
            {theform && theform === 'voluntariat_goel' &&
                <ModalForm
                  data={formVolunteer}
                  sendmessage={sendMessage}
                  showmessage={showmessage}
                  showerrormessage={showerrormessage}
                  lang={lang}
                  formId={theform}
                  project={project}
                />
            }

            {theform && theform !== 'voluntariat_goel' &&
                <ModalForm
                  data={formData}
                  sendmessage={sendMessage}
                  showmessage={showmessage}
                  showerrormessage={showerrormessage}
                  lang={lang}
                  formId={theform}
                  project={project}
                />
            }


            {/*children*/}
        </Modal.Body>
        <Modal.Footer>
          <div className="H5-Medium-C---black p-l-r-112">
            {footer}
          </div>
        </Modal.Footer>
      </Modal>
    </>
  )

 }

 const ModalForm = ({ data, sendmessage, showmessage, showerrormessage, lang, formId, project }) => {
   if(!data){
     return;
   }
   if(project && data){
     data.elements[3].attributes =
     [
        {
            "name": "#title",
            "value": "Tria un projecte"
        },
        {
            "name": "#required",
            "value": "1"
        },
        {
          "name": "#default_value",
          "option": project
        }
    ]

     data?.elements.push({
       'key': 'project-1',
       'name': 'project',
       'options': '',
       'type': 'hidden',
       'value': project,
       'attributes': [
           {
               "name": "#title",
               "value": "Project"
           },
           {
               "name": "#required",
               "value": "0"
           },
           {
               "name": "#default_value",
               "value": project
           }
       ]
     })
   }



 return(
    <div>
     <Webform
       id="visit-us-form"
       webform={data}
       endpoint={`${process.env.GATSBY_DRUPAL_API_URL}/react_webform_backend/submit`} // "http://localhost:8888/react_webform_backend/submit"
       onSuccess={(response) => showmessage(response)}
       rowClasses='col-md-6'
       className="row p-l-r-112"
       onError={(response) => showerrormessage(response)}
       lang={lang}
       formId={formId}
       customComponents={{
         webform_entity_stripe: formId && formId === 'donacio_en_linea' ? WebformEntityStripe : null
       }}
     />
     </div>
 )
 }

 const WebformEntityStripe = ({ element, error }) => {

  	const [inputProps, settings] = useWebformElement(element, {
  		name: element.name,
  		type: 'radio'
  	})

  	return (
  		<WebformElementWrapper settings={settings} error={error}>
  				<div className="form-check" key={'1'}>
  					<input id={`stripe-1`} className="form-check" {...inputProps} />
  					<label htmlFor={`stripe-1`} className="form-check-radio">
  						test
  					</label>
  				</div>
  		</WebformElementWrapper>
  	)
}

/*const useDataFormModal = () => {
  return []
}*/


 const useDataFormModal = () => {
   return useStaticQuery(graphql`
      query askPrayerQueryAndVisitUsQuery {
        form_work_with_us: webformWebform(drupal_internal__id: {eq: "treballar_goel"}) {
          drupal_internal__id
          langcode
          elements {
            name
            type
            attributes {
              name
              value
            }
          }
        }
        form_donate: webformWebform(drupal_internal__id: {eq: "donacio_en_linea"}) {
          drupal_internal__id
          langcode
          elements {
            name
            type
            attributes {
              name
              value
            }
            options {
              label
              value
            }
          }
        }
        form_prayer: webformWebform(drupal_internal__id: {eq: "ask_for_prayer"}) {
          drupal_internal__id
          langcode
          elements {
            name
            type
            attributes {
              name
              value
            }
            options {
              label
              value
            }
          }
        }
        form_welcome: webformWebform(drupal_internal__id: {eq: "visit_us_goel_webform"}) {
          drupal_internal__id
          langcode
          elements {
            name
            type
            attributes {
              name
              value
            }
            options {
              label
              value
            }
          }
        }
        form_volunteer: webformWebform(drupal_internal__id: {eq: "voluntariat_goel"}) {
          drupal_internal__id
          langcode
          elements {
            name
            type
            attributes {
              name
              value
            }
            options {
              label
              value
            }
          }
        }
      }

    `)
 }



export default ModalUnida
